<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_WithdrawalListOfLinkedConsignors')"
      width="500px"
      class="make-invoice-adjust-balance-dialog"
      :close-on-click-modal="false"
      :show-close="true"
      @close="cancel"
    >
      <div>
        <div>
          <div class="form-row" style="flex-direction:row;max-width: 920px">
            <el-form
              label-width="100px"
              label-position="left"
              style="margin-right:20px"
            >
              <cargo-ag-grid
                ref="backList"
                :show-side-bar="false"
                :grid-options="options"
                :column-defs="column"
                :row-data="rowList"
                style="width: 100%;min-width: 180px"
                @gridReady="params=>{gridApi=params.api}"
              />
            </el-form>
          </div>
        </div>
        <div class="spacing" />
        <div class="triggers" align="right">
          <el-button no="confirm" type="primary" @click="cancel">
            {{ $t('common.btn.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'BackListWindow',
  components: { CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    rowList: { type: Array, required: false }
  },
  data() {
    return {
      loading: false,
      gridApi: null,
      options: {
        columnApi: null
      },
      column: [
        {
          headerName: this.$t('CargoMsg.Cargo_OperatingCompany'), colId: 'companyCName', field: 'companyCName', width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WriteOffNo'), colId: 'fileNo', field: 'fileNo', width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SendingDate'), colId: 'sendDate', field: 'sendDate', width: 150,
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Status'), colId: 'state', field: 'state', width: 100,
          cellRenderer: params => {
            return ColumnUtils.fileStatusLabelFunc(params.value)
          }
        }
      ]
    }
  },
  computed: {
    innerVisible() {
      return this.visible
    }
  },
  async beforeMount() {

  },
  methods: {
    cancel() {
      this.$emit('visibleHandler')
    }
  }
}
</script>
<style scoped>

ul li {
  list-style: none;
  font-size: 13px;
  color: #909399;
}

.spacing {
  padding-top: 20px;
}
</style>

